import { useEffect, useState } from 'react'
import './contador.css'

export default function Contador(props) {
    const [count, setCount] = useState({
        seg: 0,
        min: 0,
        hour: 0,
        days: 0,
        mes: 0
    });

    useEffect(() => {

        const interval = setInterval(() => {

            const datenow = new Date();
            const date = new Date(`${props.DateHour}`)
            const diferenciaMs = new Date(date - datenow)

            const segMs = 1000;
            const minMs = segMs * 60;
            const horaMs = minMs * 60;
            const diaMs = horaMs * 24;
            const mesMs = diaMs * 30;

            setCount(v => ({
                ...v,
                seg: Math.floor((diferenciaMs % minMs) / segMs),
                min: Math.floor((diferenciaMs % horaMs) / minMs),
                hour: Math.floor((diferenciaMs % diaMs) / horaMs),
                days: Math.floor((diferenciaMs % mesMs) / diaMs),
                month: Math.floor(diferenciaMs / mesMs),
            }));
        }, 1000);

        return () => clearInterval(interval);

    }, [props])

    return (
        <section className="Invitacion_Contador">
            <div>
                <table>
                    <tbody>
                        <tr>
                            <td className="title-text p3">{count.month}</td>
                            <td className="title-text p3">{count.days}</td>
                            <td className="title-text p3">{count.hour}</td>
                            <td className="title-text p3">{count.min}</td>
                            <td className="title-text p3">{count.seg}</td>
                        </tr>
                        <tr>
                            <td className="title-text p1">Meses</td>
                            <td className="title-text p1">Dias</td>
                            <td className="title-text p1">Horas</td>
                            <td className="title-text p1">Minutos</td>
                            <td className="title-text p1">Segundos</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </section>
    )
}
